import './App.css';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import {BrowserRouter as Router} from 'react-router-dom';
//import ReactFluidScroll from 'react-fluid-scroll';
import React, {useRef, useEffect} from 'react';
import useWindowSize from './components/WindowSize/useWindowSize';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AnimatedCursor from "react-animated-cursor";
//import CustomCursor from 'custom-cursor-react';
import 'custom-cursor-react/dist/index.css';
//import ServicesSection from './components/Services';

function App() {

  const size = useWindowSize();

  // Ref for parent div and scrolling div
  const app = useRef();
  const scrollContainer = useRef();

  // Configs
  const data = {
    ease: 0.1,
    current: 0,
    previous: 0,
    rounded: 0
  };

  // Run scrollrender once page is loaded.
  useEffect(() => {
    requestAnimationFrame(() => skewScrolling());
  },[]);

  //set the height of the body.
  useEffect(() => {
    setBodyHeight();
  }, [size.height]);

  //Set the height of the body to the height of the scrolling div
  const setBodyHeight = () => {
    document.body.style.height = `${
      scrollContainer.current.getBoundingClientRect().height
    }px`;
  };

  // Scrolling
  const skewScrolling = () => {
    //Set Current to the scroll position amount
    data.current = window.scrollY;
    // Set Previous to the scroll previous position
    data.previous += (data.current - data.previous) * data.ease;
    // Set rounded to
    data.rounded = Math.round(data.previous * 100) / 100;

    // Difference between
    const difference = data.current - data.rounded;
    const acceleration = difference / size.width;
    const velocity = +acceleration;
    var optValue = 3.5;
    /*if (scrollContainer.current.getBoundingClientRect().width > 650){
      optValue = 7.5;
    }
    else optValue = 1;*/
    //console.log(optValue);
    const skew = velocity * optValue;

    //Assign skew and smooth scrolling to the scroll container
    if (scrollContainer.current.getBoundingClientRect().width < 700){
      scrollContainer.current.style.transform = `translate3d(0, -${data.current}px, 0)`;
    }
    else scrollContainer.current.style.transform = `translate3d(0, -${data.rounded}px, 0) skewY(${skew}deg)`;

    //loop vai raf
    requestAnimationFrame(() => skewScrolling());
  };

  

  return (
    
    <Router>
      <div ref={app} className="App">
      <AnimatedCursor
      innerSize={15}
      outerSize={18}
      color='10, 250, 10'
      outerAlpha={0.2}
      innerScale={0.6}
      outerScale={5}
    />
       {/* <CustomCursor
      targets={['.link', '.element']}
      customClass='custom-cursor'
      dimensions={74}
      fill='transparent'
      strokeWidth='3'
      strokeColor='#4AF626'
      smoothness={{
        movement: 0.3,
        scale: 0.2,
        opacity: 0.7,
      }}
      targetOpacity={0.5}
    />*/}
        
        <div ref={scrollContainer} className="scroll">
        
        
          <Navbar/>
          <Hero id="home"/>
          <About id="about"/> 
               
          <Projects id="projects"/>
          <Contact id="contact"/>
          <Footer/>
    </div>
    </div>
    </Router>
    
    
    
    
  );
}

export default App;
